import { css, html } from "lit";
import "../../atom/Icon/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
import { prop } from "../../../decorators/prop/index.js";
import { getDividerClasses, getArrowClasses } from "./utils.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfFormGroupDivider = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_size = "medium";
  }
  render() {
    this.style.setProperty(
      "--dsf-form-group-divider-size",
      this.dsf_size === "small" ? "calc(1.2 * var(--dsf-base-size))" : "calc(1.4 * var(--dsf-base-size))"
    );
    return html` <div class=${getDividerClasses(this)}>
      <dsf-icon dsf_name="ArrowRight" class=${getArrowClasses(this)}></dsf-icon>
    </div>`;
  }
};
DsfFormGroupDivider.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        --dsf-form-group-divider-size: calc(1.4 * var(--dsf-base-size));
        width: var(--dsf-form-group-divider-size);
        height: var(--dsf-form-group-divider-size);
        display: inline-flex;
      }
    `
];
__decorateClass([
  prop({ type: String, reflect: true })
], DsfFormGroupDivider.prototype, "dsf_size", 2);
DsfFormGroupDivider = __decorateClass([
  defineElement("dsf-form-group-divider")
], DsfFormGroupDivider);
export {
  DsfFormGroupDivider
};
